
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      storeList: [],
    };
  },
  destroyed() {
    if (this.storeList.length === 0) return;

    const isMatched = this.$router
      .getMatchedComponents()
      .some(component => this.constructor === component);

    if (!isMatched) {
      // current store before destroy
      this.storeList.forEach(store =>
        this.$store.dispatch(store.ResetState.namespaced(null))
      );
    }
  },
});
